<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="dialog = true" depressed>新しい{{ $route.name }}を作成</v-btn>
      </section>

      <v-card flat>
        <v-data-table
          :headers="headers"
          :items="functions"
          :loading="loading">
          <template v-slot:item="{ item }">
            <template v-if="isEnabled(item.name)">
              <tr>
                <td v-for="(value, key) in item" :key="key">
                  <template v-if="key == 'name'">
                    {{ value }}
                  </template>
                  <template v-else>
                    <v-checkbox
                      v-model="item[key]"
                      @change="enableChange(item.name, key, item[key])" />
                  </template>
                </td>
              </tr>
            </template>
          </template>
        </v-data-table>
      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" width="600" class="edit-dialog" fixed temporary right stateless>
        <v-card flat class="drawer-card">
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ $route.name }}を追加</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="name"
                    label="ロール名"
                    v-model="editedItem.name"
                    :rules="[rules.required]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="addRole" :loading="saving" :disabled="!valid" text x-large>
              <v-icon left>fas fa-save</v-icon>登録
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { createRole, updateRole, deleteRole } from '../graphql/mutations'
import { listRoles, listAppOptions } from '../graphql/queries'
import { onCreateRole, onUpdateRole, onDeleteRole } from '../graphql/subscriptions'

export default {
  data() {
    return {
      loading: true,
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      allowed: [],
      roles: [],
      editedIndex: -1,
      editedItem: {},
    }
  },
  prop: {},
  mounted: async function() {
    //利用可能な機能 query
    const query = await API.graphql(graphqlOperation(listAppOptions, {
      filter: {
        tag: { eq: 'systemConfig' }
      },
      limit: 1000,
    }))
    for (const row of query.data.listAppOptions.items) {
      switch (row.name) {
        case 'functions':
          this.allowed = row.value.split(',')
          break
        default:
          break
      }
    }
    //機能一覧
    for (const route of this.$router.options.routes) {
      if (route.children) {
        for (const scene of route.children) {
          this.desserts.push({
            name: scene.name,
          })
        }
      }
    }
    //権限一覧 query
    await this.getRoles()
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateRole)).subscribe({
      next: (e) => {
        const data = e.value.data.onCreateRole
        this.updateRole(data)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateRole)).subscribe({
      next: (e) => {
        const data = e.value.data.onUpdateRole
        this.roles.find(origin => {
          if (origin.id === data.id) {
            origin = Object.assign(origin, data)
          }
        })
        this.updateRole(data)
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteRole)).subscribe({
      next: (e) => {
        const data = e.value.data.onDeleteRole
        this.roles = this.roles.filter(origin => origin.id !== data.id)
      }
    })
    this.loading = false
  },
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    headers() {
      const column = []
      column.push({
        text: '機能',
        align: 'start',
        value: 'name',
        sortable: false,
      })
      for (const role of this.roles) {
        column.push({
          text: role.name,
          align: 'start',
          value: role.id,
          sortable: false,
        })
      }
      return column
    },
    items() {
      const map = []
      for (const route of this.$router.options.routes) {
        if (route.children) {
          for (const scene of route.children) {
            const item = {
              name: scene.name,
            }
            for (const role of this.desserts) {
              if (role.functions && role.functions.find(e => e.name === scene.name) != false) {
                item[role.id] = true
              } else {
                item[role.id] = false
              }
            }
            map.push(item)
          }
        }
      }
      return map
    },
    functions() {
      const map = []
      for (const item of this.desserts) {
        if (this.isEnabled(item.name)) {
          map.push(item)
        }
      }
      return map
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //保存
    async addRole() {
      try {
        this.saving = true
        const data = Object.assign({}, this.editedItem)
        //ロールの追加
        await API.graphql(graphqlOperation(createRole, {input: data}))
        this.log({ type: this.$route.name, text: data.name + ' を追加しました' })
        this.dialog = false
      } catch (error) {
        this.myAlert(error.message)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        const data = { id: this.editedItem.id }
        await API.graphql(graphqlOperation(deleteRole, {input: data}))
        this.myAlert(this.$route.name + 'を削除しました', 'success')
        this.dialog = false
      } catch (error) {
        this.myAlert(error)
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f]) this.$refs[f].reset()
      })
      this.editedItem.id = null
    },
    //権限の取得
    async getRoles(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listRoles, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listRoles.items) {
        this.updateRole(data)
      }
      if (query.data.listRoles.nextToken) this.getRoles(query.data.listRoles.nextToken)
    },
    //ロールの更新
    updateRole(role) {
      if (!this.roles.find(e => e.name == role.name)) this.roles.push(role)
      const list = role.functions ? role.functions : []
      for (const item of this.desserts) {
        const col = list.find(e => e.name === item.name)
        item[role.id] = col ? col.enabled : false
      }
    },
    //権限の変更
    async enableChange(scene, role, value) {
      const data = this.roles.find(e => e.id === role)
      const org = data.functions || []
      const items = []

      for (const func of org) {
        items.push({
          name: func.name,
          enabled: func.enabled,
          permission: func.permission || null,
        })
      }

      const item = items.find(e => e.name === scene)
      if (item) {
        item.enabled = value
      } else {
        items.push({
          name: scene,
          enabled: value,
        })
      }

      await API.graphql(graphqlOperation(updateRole, {input: {
        id: role,
        functions: items
      }}))
      this.log({ type: this.$route.name, text: '権限を更新しました' })

      //this.myAlert('権限を変更しました。権限を反映するには一度ログアウトしてください。', 'success')
    },
    //機能の利用可能チェック
    isEnabled(name) {
      return this.allowed.find(e => e === name) ? true : false
    }
  },
}
</script>

<style lang='scss'>

</style>
